























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RichText, RichTextBuilding, RichTextElement } from "../../graphics/rich-text";
import { Building as BuildingEnum, Faction, Resource } from "@gaia-project/engine";
import Reward from "@gaia-project/engine/src/reward";
import Building from "../Building.vue";
import SpecialAction from "../SpecialAction.vue";
import { foregroundColor } from "../../graphics/colors";
import { factionColorVar } from "../../graphics/utils";
import BoardAction from "../BoardAction.vue";
import TechTile from "../TechTile.vue";
import Booster from "../Booster.vue";

@Component({
  components: { Booster, TechTile, BoardAction, Building, SpecialAction },
})
export default class RichTextView extends Vue {
  @Prop()
  content: RichText;

  get filteredContent(): RichText {
    return this.content.flatMap(c => {
      if (c.rewards) {
        return c.rewards.map(r => ({ rewards: [r] } as RichTextElement));
      }
      return c;
    });
  }

  scale(r: Resource): number {
    switch (r) {
      case Resource.VictoryPoint:
        return 1.3;
      case Resource.ChargePower:
      case Resource.PayPower:
        return 1;
    }
    return 1.15;
  }

  y(r: Resource): number {
    switch (r) {
      case Resource.ChargePower:
      case Resource.PayPower:
        return 2;
    }
    return 0;
  }

  width(rewards: Reward[]): number {
    return rewards[0].count as any == "+" ? 15 : rewards.length * 30;
  }

  buildingResource(b: RichTextBuilding): Resource | null {
    if (b.skipResource) {
      return null;
    }
    switch (b.type) {
      case BuildingEnum.Academy1:
        return Resource.Knowledge;
      case BuildingEnum.Academy2:
        return b.faction === Faction.BalTaks ? Resource.Credit : Resource.Qic;
    }
    return null;
  }

  buildingCountStyle(b: RichTextBuilding): string {
    return `fill: ${(foregroundColor(factionColorVar(b.faction)))}; font-weight: bold;`;
  }
}
